import { Box, Container, Typography } from '@mui/material';
import photo from '../assets/HeadBack.webp';
import PageBanner from './SectionPageBanner';

const Careers = () => {
  return (
    <Box sx={{ backgroundColor: '#fcfcfc', minHeight: '100vh'}}>
         <PageBanner image={photo} title="Careers" />
      <Container maxWidth="md">

        <Typography
          variant="body1"
          align="center"
          sx={{ px: '30px', mb: 5,mt:5, color: 'text.secondary' }}
        >
          We’re always on the lookout for passionate individuals who want to
          build impactful tech solutions. Join a team where creativity and
          innovation thrive.
        </Typography>

        <Typography
          variant="h6"
          align="center"
          sx={{ px: '30px', color: '#666' }}
        >
          Currently, there are no open positions. Please check back later.  
          <br />
          Thank you for your interest in being a part of our journey!
        </Typography>
      </Container>
    </Box>
  );
};

export default Careers;
